<template>
  <div ref="root">
    <div ref="button" @click="showPopup = !showPopup">
      <slot name="button"></slot>
    </div>

    <PopUp
      v-if="!renderOnShow || finalShow"
      :show="finalShow"
      :placement="placement"
      :offset="offset"
      :reference="button"
      v-slot="slotProps"
    >
      <slot
        name="popup"
        :visible="finalShow"
        :forceUpdate="slotProps.forceUpdate"
      ></slot>
    </PopUp>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import type { Placement } from "@popperjs/core/lib/enums";
import { useOnClickOutside } from "@/composables";
import PopUp from "@/components/utils/PopUp.vue";

const props = defineProps<{
  placement: Placement;
  offset: number;
  forceShow?: boolean;
  renderOnShow?: boolean;
}>();

const button = ref<HTMLElement | null>(null);
const root = ref<HTMLElement | null>(null);
const showPopup = ref(false);
const finalShow = computed(() => showPopup.value || (props.forceShow ?? false));

useOnClickOutside(root, () => (showPopup.value = false));

defineExpose({ show: (on: boolean) => (showPopup.value = on) });
</script>
